// src/app/core/services/dropdown.service.ts
import { Injectable } from '@angular/core';
import { HttpRequesterService } from '../http-requester.service';
import { ApiEndpoints } from '../../constants/api-endpoints';

export type DropdownKey =
  | 'BANKS'
  | 'LEVELS'
  | 'LGA'
  | 'SERVICETYPES'
  | 'OWNERSHIPTYPES'
  | 'PAYMENTREFERENCE'
  | 'PROVIDERCATEGORY'
  | 'SERVICEPOINTS'
  | 'SIGNATORYROLES'
  | 'STATES'
  | 'COUNTRIES';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  constructor(private readonly http: HttpRequesterService) {}

  /**
   * Fetches dropdown values based on one or more keys.
   * @param keys A single key or an array of keys.
   */
  getDropdownValues(keys: string | string[]) {
    const requestBody = {
      keys: Array.isArray(keys) ? keys : [keys],
    };

    return this.http.post(ApiEndpoints.Dropdown.Common, requestBody, {
      headers: { 'x-error-handled': 'true' },
    });
  }

  getCommonDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.Common,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }

  getPolicyPlanDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyPlans,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }

  getPolicyPackageDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyPackages,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }

  getPolicyProgramDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyPrograms,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }
  getPolicyTariffDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyTariffs,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }
  getPolicyServiceDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyServices,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }
  getPolicyDrugDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyDrugs,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }
  getPolicyCapitationDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyCapitations,
      { keys },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );
  }
  getPolicyPremiumDropdowns(keys: string[]) {
    return this.http.post(
      ApiEndpoints.Dropdown.PolicyPremiums,
      { keys
      },
      {
        headers: { 'x-error-handled': 'true' },
      },
    );

   
  }
   getNonAuthDropdowns(keys: string[]) {
      return this.http.post(
        ApiEndpoints.Dropdown.NonAuth,
        { keys },
        {
          headers: { 'x-error-handled': 'true' },
        },
      );
    }
}
